import Config from '../Config';
import axios from 'axios';

export async function fetchBusinessInfo(businessId) {
    const apiPath = `public/business/${businessId}/get-business-info`;

    const request = {
        url: `https://${Config.DYNAMO_API_URL}/${apiPath}`,
        // url: `http://localhost:3001/${apiPath}`,
        host: Config.DYNAMO_API_URL,
        path: apiPath,
        method: 'GET',
        region: Config.AWS_REGION,
        service: 'execute-api',
        validateStatus: () => true,
    };
    const response = await axios(request);

    return response.data;
}